/**
 * DASHBOARD-CARD-TITLE
 * Titre d'une carte du tableau de bord, avec son lien vers la page detaillee
 */
import Link from "@/components/link"
import { IconDefinition } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

//Elements affiches au plus dans une carte du tableau de bord, meme quand la place en permet davantage
export const DASHBOARD_MAX_ITEMS = 6

interface Props {
  icon: IconDefinition
  title: string
  onDetailClick?: () => void
}

export default function DashboardCardTitle({ icon, title, onDetailClick }: Props) {
  return (
    <div className="flex min-w-0 flex-1 flex-wrap items-center gap-x-[10px] gap-y-[8px] text-base font-bold">
      <span className="flex flex-1 items-center gap-[10px] whitespace-nowrap">
        <FontAwesomeIcon icon={icon} className="blue-t shrink-0" />
        <span>{title}</span>
      </span>
      {onDetailClick && (
        //La carte entiere mene deja a la meme page : un seul navigate
        <Link
          isWithoutMargin
          className="shrink-0 whitespace-nowrap font-normal"
          onClick={(event) => {
            event.stopPropagation()
            onDetailClick()
          }}>
          Afficher le détail
        </Link>
      )}
    </div>
  )
}
